import { API_CONFIG } from "../config/api";
import { ApiResponse } from "../types";
import { StatMonthlyResponse } from "../types/stat";
import { http, buildUrl } from "./base";

/**
 * 数据统计相关服务
 */
export class StatService {
  /**
   * 获取充值月度统计
   * @param month 月份，格式 YYYY-MM，例如 2025-11
   * @param orgId 可选组织 ID
   */
  static async getRechargeMonthly(params: {
    month: string;
    orgId?: number;
  }): Promise<ApiResponse<StatMonthlyResponse>> {
    const url = buildUrl(API_CONFIG.ENDPOINTS.STAT.RECHARGE_MONTHLY);
    return http.get<StatMonthlyResponse>(url, params);
  }

  /**
   * 获取消耗月度统计
   * @param month 月份，格式 YYYY-MM，例如 2025-11
   * @param orgId 可选组织 ID
   */
  static async getConsumeMonthly(params: {
    month: string;
    orgId?: number;
  }): Promise<ApiResponse<StatMonthlyResponse>> {
    const url = buildUrl(API_CONFIG.ENDPOINTS.STAT.CONSUME_MONTHLY);
    return http.get<StatMonthlyResponse>(url, params);
  }
}

export default StatService;